/** Protokol multiplayer Slime Brawler (dipakai klien + worker). */

export const MAX_PLAYERS = 4;
export const STAGE_COUNT = 10;
export const CHAT_MAX_LEN = 160;
export const CHAT_MIN_INTERVAL_MS = 500;
export const ROOM_CODE_LENGTH = 6;
/** Tanpa karakter ambigu (0/O/1/I). */
export const ROOM_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const NET_STATE_HZ = 15;
export const DEFAULT_SLIME_COLORS = [
  '#5dffd4',
  '#ff6b9d',
  '#ffd166',
  '#6aa8ff',
  '#b48ead',
  '#a3e635',
];

export interface PlayerInfo {
  id: string;
  name: string;
  color: string;
  host: boolean;
}

/** playerId -> indeks spawn (0..3). */
export type SpawnAssign = Record<string, number>;

// ---- klien -> server ----

export type ClientMessage =
  | { t: 'hello'; name: string; color: string }
  | { t: 'color'; color: string }
  | { t: 'ready' }
  | { t: 'stage'; index: number }
  | { t: 'chat'; text: string }
  | { t: 'state'; x: number; y: number; z: number; yaw: number; anim: string };

// ---- server -> klien ----

export type ServerMessage =
  | { t: 'welcome'; id: string; code: string; players: PlayerInfo[]; started: boolean; spawns: SpawnAssign; stage: number }
  | { t: 'players'; players: PlayerInfo[] }
  | { t: 'stage'; index: number }
  | { t: 'start'; spawns: SpawnAssign; stage: number }
  | { t: 'chat'; id: string; name: string; text: string }
  | { t: 'state'; id: string; x: number; y: number; z: number; yaw: number; anim: string }
  | { t: 'bye'; id: string }
  | { t: 'error'; message: string };

export function sanitizeName(raw: unknown): string {
  if (typeof raw !== 'string') return 'Slime';
  const clean = raw.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 16);
  return clean.length > 0 ? clean : 'Slime';
}

export function sanitizeColor(raw: unknown, fallback = DEFAULT_SLIME_COLORS[0]): string {
  if (typeof raw === 'string' && /^#[0-9a-fA-F]{6}$/.test(raw)) return raw.toLowerCase();
  return fallback;
}

export function isValidCode(raw: unknown): raw is string {
  if (typeof raw !== 'string' || raw.length !== ROOM_CODE_LENGTH) return false;
  for (const ch of raw.toUpperCase()) {
    if (!ROOM_ALPHABET.includes(ch)) return false;
  }
  return true;
}

export function normalizeCode(raw: string): string {
  return raw.toUpperCase();
}

export function randomCode(pick: (n: number) => number): string {
  let out = '';
  for (let i = 0; i < ROOM_CODE_LENGTH; i++) {
    out += ROOM_ALPHABET[pick(ROOM_ALPHABET.length) % ROOM_ALPHABET.length];
  }
  return out;
}

export function isFiniteNumber(n: unknown): n is number {
  return typeof n === 'number' && Number.isFinite(n);
}

/** Index stage 0..STAGE_COUNT-1, di luar itu jadi 0. */
export function clampStageIndex(raw: unknown): number {
  if (!isFiniteNumber(raw)) return 0;
  const i = Math.floor(raw);
  if (i < 0 || i >= STAGE_COUNT) return 0;
  return i;
}

/** Bersihkan teks chat: buang kontrol, batas panjang. '' = abaikan. */
export function sanitizeChat(raw: unknown): string {
  if (typeof raw !== 'string') return '';
  const clean = raw.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, CHAT_MAX_LEN);
  return clean;
}
